































































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

import FlatpageLegalBase from 'frontend/views/flatpages/FlatpageLegalBase.vue';

@Component({
  metaInfo() {
    return {
      title: 'Privacy Policy (March 24, 2014 - May 21, 2018)',
    };
  },
  components: {
    FlatpageLegalBase,
  },
  computed: {
    ...mapGetters('pageHeader', ['isMobile']),
  },
})
export default class PrivacyPolicy2014 extends Vue {}
